import { Image } from "react-bootstrap";
import { Interaction } from "../../../../@types/Interaction";
import { User } from "../../../../@types/Users";
import { useState, useEffect } from "react";
import { isEqual } from "lodash";
import { BiTrash } from "react-icons/bi";
import Swal from "sweetalert2";
import { projectPrimaryColor } from "../../../../generalConfigs";
import usePostContext from "../../../../context/PostContext";
import { getTimeDiferenceTitle } from "../../../../utils";
import useProfilePicture from "../../../../hooks/useProfilePicture";
import useInteraction from "../../../../hooks/useInteraction";
import { useUser } from "../../../../hooks/useUser";

interface Props {
  comment: Interaction;
  user: User;
}

export default function Comment({ comment }: Props) {
  const [isOwner, setIsOwner] = useState<boolean>(false);
  const { interactions, setInteractions } = usePostContext();
  const { user, content } = comment;
  const { getProfilePictureURI } = useProfilePicture();
  const { doDestroy } = useInteraction();
  const { getUserDetailsWithCache } = useUser();

  useEffect(() => {
    async function determineIsOwner() {
      const loggedUser = await getUserDetailsWithCache();

      if (loggedUser) {
        const newIsOwner = isEqual(loggedUser.id, comment.user.id);
        setIsOwner(newIsOwner);
      }
    }

    determineIsOwner();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleDestroy() {
    Swal.fire({
      title: "Tem certeza?",
      text: "Essa ação não pode ser revertida.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: projectPrimaryColor,
      cancelButtonColor: "gray",
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
      background: "var(--bg-1)",
      color: "var(--text-1)",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const newInteractionsContextState = interactions.filter(
          (interaction) => interaction.id !== comment.id
        );

        setInteractions(newInteractionsContextState);

        await doDestroy(comment.id);
      }
    });
  }

  return (
    <div className="d-flex mg-b-20">
      <Image
        src={getProfilePictureURI(user.profile_picture)}
        className="mg-r-10 img-xs rounded-circle mg-r-5"
        style={{ objectFit: "cover", minWidth: 37, minHeight: 37 }}
      />

      <div className="card bd-0 wd-100p" style={{ borderRadius: 10 }}>
        <div
          className="card-header tx-medium bd bd-b-0"
          style={{
            borderRadius: 10,
            backgroundColor: "var(--bg-2)",
            borderEndEndRadius: 0,
            borderEndStartRadius: 0,
            borderColor: "var(--border)",
          }}
        >
          {user.name}

          {isOwner && (
            <i className="float-right cursor-pointer" onClick={handleDestroy}>
              <BiTrash size={22} />
            </i>
          )}
          {
            <span
              className="tx-11 pd-l-5 float-right"
              style={{ marginRight: isOwner ? 10 : 0 }}
            >
              {getTimeDiferenceTitle(comment.created_at)} atrás
            </span>
          }
        </div>
        <div
          className="card-body bd bd-t-0"
          style={{
            borderRadius: 10,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderColor: "var(--border)",
          }}
        >
          <p className="mg-b-0">{content}</p>
        </div>
      </div>
    </div>
  );
}
